import React, { useState, useEffect } from 'react';
import OneSignal from 'react-onesignal';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { BellIcon, XMarkIcon } from '@heroicons/react/24/outline';

const NotificationPrompt = () => {
  const [show, setShow] = useState(false);
  const [requesting, setRequesting] = useState(false);

  useEffect(() => {
    const checkPermission = async () => {
      try {
        // Attendi che OneSignal sia inizializzato
        await new Promise(resolve => setTimeout(resolve, 2000));
        
        const isSubscribed = await OneSignal.User.pushSubscription.getIsSubscribed();
        
        // Mostra prompt solo se non è già sottoscritto
        if (!isSubscribed) {
          setShow(true);
        }
      } catch (error) {
        console.error('Errore controllo permessi:', error);
      }
    };

    checkPermission();
  }, []);

  const handleEnableNotifications = async () => {
    setRequesting(true);
    try {
      // Richiedi permesso per le notifiche
      await OneSignal.Notifications.requestPermission();
      
      // Controlla se ha accettato
      const isSubscribed = await OneSignal.User.pushSubscription.getIsSubscribed();
      
      if (isSubscribed) {
        console.log('Notifiche abilitate con successo');
        setShow(false);
      } else {
        console.log('Permesso negato dall\'utente');
      }
    } catch (error) {
      console.error('Errore richiesta permessi:', error);
    } finally {
      setRequesting(false);
    }
  };

  if (!show) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-md">
      <Card className="shadow-2xl border-blue-500 border-2">
        <CardHeader className="pb-3">
          <div className="flex items-start justify-between">
            <BellIcon className="w-10 h-10 text-blue-600 mr-3" />
            <button
              onClick={() => setShow(false)}
              className="text-gray-400 hover:text-gray-600"
            >
              <XMarkIcon className="w-5 h-5" />
            </button>
          </div>
          <CardTitle className="text-lg">Resta Aggiornato sui Tuoi Premi</CardTitle>
          <CardDescription>
            Abilita le notifiche per ricevere aggiornamenti istantanei
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <ul className="text-sm text-gray-600 space-y-2">
            <li className="flex items-center">
              <span className="mr-2">🎉</span>
              Quando guadagni punti
            </li>
            <li className="flex items-center">
              <span className="mr-2">🎁</span>
              Nuovi premi disponibili
            </li>
            <li className="flex items-center">
              <span className="mr-2">🎂</span>
              Offerte speciali di compleanno
            </li>
            <li className="flex items-center">
              <span className="mr-2">⭐</span>
              Promozioni esclusive
            </li>
          </ul>

          <div className="flex gap-2">
            <Button
              onClick={handleEnableNotifications}
              disabled={requesting}
              className="flex-1"
            >
              {requesting ? 'Configurazione...' : 'Abilita Notifiche'}
            </Button>
            <Button
              onClick={() => setShow(false)}
              variant="outline"
              className="flex-1"
            >
              Più Tardi
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default NotificationPrompt;
